import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

export type TGetProductInventory = {
  id?: string | number;
  variant_id?: string | number;
  extended?: boolean;
  variant_ids?: Array<number>;
};

export type TPutProductInventory = {
  variant_id: string | number;
  price?: number;
  cost?: number;
  price_override?: number;
  cost_override?: number;
  quantity_available?: number;
  quantity_receiving?: number;
  tax_line_ids?: Array<string | number>;
};

export type TInventory = {
  id: string | number;
  facility_id: string | number;
  processed_at: string; // ie. "2023-07-11 13:00:21"
  admin_user_id: string | number;
  admin_user_full_name: string;
  vendor_title: string;
};
interface IPutInventoryRecords {
  id: number;
  vendor_id?: number;
  packing_slip_number?: string;
  po_number?: string;
  processed_at?: string;
}

// GET Inventory Levels
export async function GetInventoryLevels(params: TGetProductInventory, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/product/inventory/level"), params, useGlobalLoader, token);
}

// PUT Update Inventory Level
export async function UpdateInventoryLevels(params: TPutProductInventory, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/product/inventory/level"), params, useGlobalLoader);
}

export async function GetInventoryRecord(
  params: { id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/product/inventory/record"), params, useGlobalLoader, token);
}

export async function GetInventoryRecordsAll(
  params: { offset?: number; limit?: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<TInventory[]>(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/record/all"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function GetInventoryLog(
  params: { inventory_record_id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/product/inventory/record/log"), params, useGlobalLoader, token);
}

export async function PutInventoryLevelLog(
  params: { inventory_level_log_id: string | number, cost: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/product/inventory/level/log"), params, useGlobalLoader, token);
}

export async function GetInventoryLogsAll(
  params: { inventory_level_id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/record/log/all"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PrintInventoryLogs(
  params: { inventory_record_id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/record/log/print"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function ExportInventoryLogs(
  params: { inventory_record_id: string | number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIPut(
    APIUrl(AdminType.FacilityAdmin, "/product/inventory/record/log/export"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostInventoryRecords(
  params: {
    variants: Array<{ variant_id: number; quantity_receiving: number }>;
    vendor_id?: number;
    packing_slip_number: string;
    po_number: string;
    purchase_order_id: number;
  },
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/product/inventory/record"), params, useGlobalLoader);
}

export async function PutInventoryRecord(params: IPutInventoryRecords, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/product/inventory/record"), params, useGlobalLoader);
}
